import { ref, watch, computed } from '@vue/composition-api';
import axios from '@axios';
import useAuth from '@/auth/useAuth';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
const { i18n } = useI18nUtils();
function i18nT(str){
    return i18n(str)
  };
export default function useSurveyList(isTemplate) {
  const refDocumentListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: 'checkbox', label: '', thClass: 'tbl-chk', tdClass: 'tbl-chk' },
    { key: 'label', label: i18nT(`Title`), sortable: true, thClass: 'pl-1', tdClass: 'pl-1' },
    { key: 'type', label: i18nT(`Type`), sortable: true },
    { key: 'audience', label: i18nT(`Audience`), sortable: true },
    { key: 'created', label: i18nT(`Created On`), sortable: true, thClass: "sk-header-content" },
    { key: 'SentAt', label: i18nT(`Sent On`), sortable: true, thClass: "sk-header-content" },
    {
      key: 'action',
      label: i18nT(`Actions`),
      thClass: 'tbl-actions',
      tdClass: 'sticky-column',
      stickyColumn: true
    },
  ];
  const perPage = ref(10);
  const totalDocuments = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref('');
  const sortBy = ref('id');
  const isSortDirDesc = ref(true);
  const surveyType = ref('');
  const surveyStatus = ref('');
  const surveyOrder = ref('');
  const group = ref(null);
  const surveys = ref([]);

  const dataMeta = computed(() => {
    const localItemsCount = refDocumentListTable.value ?
      refDocumentListTable.value.localItems.length :
      0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalDocuments.value,
    };
  });

  const refetchData = () => {
    refDocumentListTable.value.refresh();
  };

  watch(
    [
      currentPage,
      perPage,
      searchQuery,
      surveyType,
      surveyStatus,
      surveyOrder,
      group,
    ],
    () => {
      refetchData();
    }
  );

  const fetchSurveys = (ctx, callback) => {
    const params = {
      page: currentPage.value,
      show_per_page: perPage.value,
      sort_by: sortBy.value,
      sort_order: isSortDirDesc.value ? 'DESC' : 'ASC',
      search: searchQuery.value
    };

    if (isTemplate) {
      params.templates = 1;
    }

    if (surveyType.value != null && surveyType.value !== '') {
      params['filters[type]'] = surveyType.value;
    }
    if (surveyStatus.value != null && surveyStatus.value !== '') {
      params['filters[status]'] = surveyStatus.value;
    }

    axios
      .get(`surveys`, {
        params,
      })
      .then(({ data }) => {
        surveys.value = data.data.surveys;
        callback(data.data.surveys);
        totalDocuments.value = data.data.pagination.records_count;
      });
  };

  return {
    fetchSurveys,
    tableColumns,
    perPage,
    currentPage,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refDocumentListTable,
    totalDocuments,
    surveyType,
    surveyStatus,
    surveyOrder,
    group,
    surveys,
    refetchData,
  };
}
